const NOOP = () => {
    // noting!!!
};
const STOP_EVENT_PROPAGATION = (ev) => {
    ev.stopPropagation();
};

export { NOOP, STOP_EVENT_PROPAGATION };
